import * as React from "react";
import { Button } from "@jhool-io/fe-components";
import SuccessIcon from "../../../../components/Icons/Success";
import Loader from "../../../../shared-ui/Loader/Loader";
import { IGeneratePaymentLinkResponse } from "../../types/clients.types";
import useToast from "../../../../hooks/useToast";

interface PaymentLinkSuccessDialogProps {
    paymentLinkData: IGeneratePaymentLinkResponse | null;
    isLoading?: boolean;
}

export default function ClientPaymentLinkGenerated({
    paymentLinkData,
    isLoading = false,
}: PaymentLinkSuccessDialogProps) {
    const { toast } = useToast();

    const handleCopyLink = () => {
        if (paymentLinkData?.payment_link_url) {
            navigator.clipboard.writeText(paymentLinkData.payment_link_url);
            toast({
                mode: "success",
                message: "Link copied",
            });
        }
    };

    return (
        <div className="flex flex-col items-center justify-center py-8 px-4">
            {isLoading ? (
                <>
                    <div className="mb-6">
                        <Loader />
                    </div>
                    <h3 className="text-lg font-semibold text-text mb-2 text-center">
                        Generating payment link...
                    </h3>
                    <p className="text-sm text-text-secondary mb-6 text-center max-w-md">
                        Please wait while we create your payment link
                    </p>
                </>
            ) : (
                <>
                    <div className="mb-6">
                        <SuccessIcon />
                    </div>
                    <h3 className="text-lg font-semibold text-text mb-2 text-center">
                        Payment link generated successfully
                    </h3>
                    <p className="text-sm text-text-secondary mb-6 text-center max-w-md">
                        Share this link to collect payment
                    </p>
                    {paymentLinkData?.coded && (
                        <p className="text-sm text-danger mb-4 text-center max-w-md font-semibold">
                            IMPORTANT: An email containing the verification code
                            has been sent to the email address provided during
                            link creation. This code will be needed to access
                            the payment link.
                        </p>
                    )}
                    {paymentLinkData?.payment_link_url && (
                        <div className="w-full max-w-md mb-6">
                            <div className="bg-background-secondary p-4 rounded-lg border border-border mb-4">
                                <p className="text-xs text-text-secondary mb-2">
                                    Payment Link
                                </p>
                                <p className="text-sm text-text break-all font-mono">
                                    {paymentLinkData.payment_link_url}
                                </p>
                            </div>
                            <Button
                                onClick={handleCopyLink}
                                variant="secondary"
                                className="w-full"
                            >
                                Copy Link
                            </Button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
